import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFormikValues } from "./createQuoteFormHelper";

const useCreateQuoteForm = () => {
  const { state } = useLocation();
  const { formikValuesId } = state ?? {};

  const formik = useFormikContext();

  useEffect(() => {
    console.log("formikValuesId: ", formikValuesId);

    if (formikValuesId) {
      getFormikValues(formikValuesId, formik);
    }
  }, [formikValuesId]);

  return {};
};

export default useCreateQuoteForm;
